import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { useAccountsDomain } from 'services/accounts/accounts_domain';

import { usePangolinDomain } from 'services/pangolin/pangolin_domain';

import { Redirect } from 'pages/core/redirect/redirect';

import { BaseEditVPNClient } from './edit_vpn_client';

export const CreateVPNClient = observer(() => {
  const { pangolinID } = useParams<{ pangolinID: string }>();
  if (!pangolinID) return <Redirect />;

  const accounts = useAccountsDomain();

  const pangolin = accounts.pangolins.get(pangolinID);
  if (!pangolin) return <Redirect />;

  const domain = usePangolinDomain(pangolin.id);
  if (!domain) return <Redirect />;

  return (
    <BaseEditVPNClient
      pangolin={pangolin}
      domain={domain}
    />
  );
});
